import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "description"
}
const _hoisted_3 = {
  key: 1,
  class: "description"
}
const _hoisted_4 = { class: "bold" }
const _hoisted_5 = {
  key: 2,
  class: "description"
}
const _hoisted_6 = { class: "bold" }
const _hoisted_7 = {
  key: 3,
  class: "description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    classes: "lot-attention"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-title" }, "Attention", -1)),
        ($props.attentionType === 'release')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createTextVNode("This action will only be applied to lots that are", -1),
              _createElementVNode("span", { class: "bold" }, " NOT RELEASED", -1)
            ]))]))
          : ($props.attentionType === 'unrelease' || $props.attentionType === 'createOptions')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(`Unable to ${$props.attentionType === "unrelease" ? "unrelease" : "create option for"} `), 1),
                _createElementVNode("span", _hoisted_4, "Lot " + _toDisplayString($props.lot.title), 1),
                _cache[1] || (_cache[1] = _createTextVNode(". This lot has one or more pending Contract information forms. Please decline requests first to apply this action.", -1))
              ]))
            : ($props.attentionType === 'UnreleaseWaitingForApprove' || $props.attentionType === 'OptionWaitingForApprove')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(`Unable to ${$props.attentionType === "UnreleaseWaitingForApprove" ? "unrelease" : "create option for"} `), 1),
                  _createElementVNode("span", _hoisted_6, "Lot " + _toDisplayString($props.lot.title), 1),
                  _cache[2] || (_cache[2] = _createTextVNode(". You have already approved a Contract information form for this lot.", -1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("This action will only be applied to lots that are", -1),
                  _createElementVNode("span", { class: "bold" }, " NOT RELEASED ", -1),
                  _createTextVNode("or", -1),
                  _createElementVNode("span", { class: "bold" }, " AVAILABLE", -1)
                ]))])),
        _createElementVNode("div", { class: "controls" }, [
          _createElementVNode("button", {
            class: "button modal cancel",
            onClick: $setup.close
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button modal primary proceed",
            onClick: $setup.proceed
          }, "Proceed")
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}